// @flow
import * as React from 'react'
import { Helmet } from 'react-helmet'
import PageWrapper from 'ui/atoms/PageWrapper'
import Pagination from 'ui/atoms/Pagination'
import PageTitle from 'ui/molecules/PageTitle'

import useAuditLog from '../hooks'
import AuditLogsAction from './AuditLogAction'
import AuditLogsFilter from './AuditLogFilter'
import AuditLogsTable from './AuditLogTable'

function AuditLogsPage(): React.Node {
  const {
    currentPage,
    setPage,
    auditLogsCount,
    auditLogsQuery,
    auditLogsPages,
  } = useAuditLog()

  return (
    <PageWrapper>
      <Helmet>
        <title>AuditLogs/Zentake</title>
      </Helmet>
      <PageTitle text="Integration Logs" />

      <AuditLogsFilter />

      <AuditLogsAction />
      <AuditLogsTable />
      <Pagination.Border>
        <Pagination
          nextCallback={() => {
            if (currentPage < auditLogsPages) {
              setPage(currentPage + 1)
            }
          }}
          page={auditLogsQuery.page || 1}
          pageSize={auditLogsQuery.page_size || 10}
          previousCallback={() => {
            if (currentPage > 2) {
              setPage(currentPage - 1)
            }
          }}
          total={auditLogsCount}
        />
      </Pagination.Border>
    </PageWrapper>
  )
}

export default AuditLogsPage
